import { Controller } from "stimulus";
import bootbox from "bootbox";
export default class extends Controller {
  displayAlert(event) {
    bootbox.alert(
      `${this.data.get("message")} (${event.detail[1] || "Network Error"})`,
    );
  }
}
